var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h5",
      { staticClass: "text-grey-6 uppercase no-margin q-headline q-pb-sm" },
      [_vm._v("Persons Connected to this Company")]
    ),
    _c("div", { staticClass: "mdi-card full-width q-pa-md" }, [
      _vm.companyId
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-table", {
                  ref: "table",
                  staticClass: "q-pa-md no-shadow",
                  attrs: {
                    data: _vm.persons,
                    columns: _vm.columns,
                    filter: _vm.terms,
                    "filter-method": _vm.myFilter,
                    "row-key": "id",
                    pagination: _vm.pagination,
                    "rows-per-page-options": [0, 25, 50, 100, 250],
                    loading: _vm.loading
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "top-left",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: { "hide-underline": "" },
                              model: {
                                value: _vm.terms,
                                callback: function($$v) {
                                  _vm.terms = $$v
                                },
                                expression: "terms"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { key: "id", attrs: { props: props } },
                                [
                                  _c("q-btn", {
                                    attrs: {
                                      icon: "edit",
                                      size: "sm",
                                      flat: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(props.row.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "firstName", attrs: { props: props } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/person/edit/" + props.row.id
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.firstName))]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "lastName", attrs: { props: props } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/person/edit/" + props.row.id
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.lastName))]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "profession", attrs: { props: props } },
                                [_vm._v(_vm._s(props.row.profession))]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "emailAddress",
                                  attrs: { props: props }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + props.row.emailAddress
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.emailAddress))]
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "homeNumber", attrs: { props: props } },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "tel:" + props.row.homeNumber
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.homeNumber))]
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "workNumber", attrs: { props: props } },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "tel:" + props.row.workNumber
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.workNumber))]
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "cellNumber", attrs: { props: props } },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "tel:" + props.row.cellNumber
                                      }
                                    },
                                    [_vm._v(_vm._s(props.row.cellNumber))]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3789240592
                  )
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm.editFormModalOpen
      ? _c(
          "div",
          [
            _c(
              "q-modal",
              {
                attrs: {
                  "content-classes": "q-pa-lg",
                  "content-css": "min-width: 70vw; max-width: 95vw",
                  "no-backdrop-dismiss": "",
                  "no-esc-dismiss": ""
                },
                model: {
                  value: _vm.editFormModalOpen,
                  callback: function($$v) {
                    _vm.editFormModalOpen = $$v
                  },
                  expression: "editFormModalOpen"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "fit" },
                  [
                    _c("q-btn", {
                      staticStyle: {
                        top: "0",
                        right: "0",
                        position: "relative",
                        float: "right"
                      },
                      attrs: { flat: "", icon: "close" },
                      on: {
                        click: function($event) {
                          _vm.editFormModalOpen = false
                        }
                      }
                    }),
                    _vm.editFormModelId
                      ? _c(
                          "div",
                          [
                            _vm.relationResource
                              ? _c(
                                  "base-form",
                                  {
                                    attrs: {
                                      resource: _vm.relationResource,
                                      callback: _vm.handleEdit,
                                      "is-modal": true,
                                      id: _vm.editFormModelId
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "full-width q-mt-md q-pb-lg",
                                        attrs: { slot: "goback" },
                                        slot: "goback"
                                      },
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            icon: "close",
                                            label: "Cancel / Close",
                                            color: "grey-6",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.editFormModalOpen = false
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }